import { render } from "./UpcomingShows.vue?vue&type=template&id=7c61d566&scoped=true"
import script from "./UpcomingShows.vue?vue&type=script&lang=js"
export * from "./UpcomingShows.vue?vue&type=script&lang=js"

import "./UpcomingShows.vue?vue&type=style&index=0&id=7c61d566&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c61d566"]])

export default __exports__